import { render, staticRenderFns } from "./BlackjackSeatElement.vue?vue&type=template&id=2a0ff52a&scoped=true"
import script from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
export * from "./BlackjackSeatElement.vue?vue&type=script&lang=js"
import style0 from "./BlackjackSeatElement.vue?vue&type=style&index=0&id=2a0ff52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ff52a",
  null
  
)

export default component.exports